import { createI18n } from 'vue-i18n'

const messages = {
en: {
  tracksDownloaded: '{0} tracks downloaded',
  tracksLoaded: '{0} tracks loaded',
  placesDownloaded: '{0} places downloaded',
  placesLoaded: '{0} places loaded',
  placeTypesDownloaded: '{0} place types downloaded',
  placeTypesLoaded: '{0} place types loaded',
  tracksError: 'Error during tracks download',
  trackError: 'Error during track download',
  mainMenu: 'Main menu',
  tracks: 'Tracks',
  settings: 'Settings',
  language: 'Language',
  tracksSelectedDistance: 'Selected tracks distance',
  tracksSelectedDistanceWalk: 'walk',
  tracksSelectedDistanceBicycle: 'bicycle',
  tracksSelectedDistanceMushroom: 'mushroomings',
  tracksSelected: 'Selected {0} of {1} tracks',
  colorSaved: 'Color saved',
  colorError: 'Error during color saving',
  color: 'Color',
  name: 'Name',
  distance: 'Distance',
  type: 'Type',
  startTime: 'Start time',
  endTime: 'End time',
  status: 'Status',
  id: 'ID',
  openMenu: 'Open menu',
  closeMenu: 'Close menu',
  showMyLocation: 'Show my location',
  enterFullscreen: 'Enter fullscreen',
  exitFullscreen: 'Exit fullscreen',
  zoomIn: 'Zoom in',
  zoomOut: 'Zoom out',
  changeColor: 'Change color',
  saveTrack: 'Save track',
  doneTrack: 'Finished track',
  plannedTrack: 'Planned track',
  walkTrack: 'Walk track',
  bicycleTrack: 'Bicycle track',
  mushroomTrack: 'Mushrooming',
  centerTrack: 'Center track',
  downloadGPX: 'Download GPX file',
  groupBy: 'Group by',
  unassigned: 'Unassigned',
  walkTracks: 'Walk tracks',
  bicycleTracks: 'Bicycle tracks',
  mushroomTracks: 'Mushroomings',
  year: 'Year',
  region: 'Region',
  playTrack: 'Play track',
  stopTrack: 'Stop playing',
  playingSpeed: 'Playing speed',
  imports: 'Imports',
  importGpxFile: 'Import GPX files',
  importError: 'Import GPX file error',
  importNoTracks: 'No tracks in GPX file',
  importSuccess: 'GPX file imported successfully',
  importNoFiles: 'No files selected',
  regionsDownloaded: '{0} regions downloaded',
  regionsLoaded: '{0} regions loaded',
  oneTrackError: 'Track has errors',
  regionsError: 'Error during regions download',
  trackSaveTitle: 'Track save',
  uploadTrack: 'Save track',
  trackSaved: 'Track saved',
  trackSavedError: 'Error during track saving',
  description: 'Description',
  loginForm: 'Login form',
  welcome: 'Welcome',
  logOut: 'Log out',
  logIn: 'Log in',
  login: 'Login',
  password: 'Password',
  logInError: 'Incorrect login or password',
  logInSuccess: 'Logged successfully',
  logInSessionExpired: 'Session has expired, log in again',
  logOutSuccess: 'Logged out successfully',
  close: 'Close',
  save: 'Save',
  maximizeTrack: 'Show details',
  gpxFile: 'GPX file',
  jsonFile: 'JSON file',
  importPhotoFile: 'Import photo',
  thumbnail: 'Thumbnail',
  photoSaveTitle: 'Add photo',
  coordinates: 'Coordinates',
  addPhotoToMap: 'Add photo',
  addPlaceToMap: 'Add place',
  photoAdded: 'Photo added',
  objects: 'Objects',
  places: 'Places',
  addPlace: 'Add place',
  newPlace: 'New place',
  fromFirstPhoto: 'From first photo',
  fromMapCenter: 'From map center',
  manually: 'Manually',
  photos: 'Photos',
  coordsError: 'Wrong GPS coordinates',
  placeSaved: 'Place saved',
  placeSavedError: 'Error during saving place',
  photoSavedError: 'Error during saving photos',
  placeRefreshError: 'Error during place download',
  trackRefreshError: 'Error during track download',
  placeCoordsSave: 'Coordinates saved',
  placeCoordsSaveError: 'Error during saving coordinates',
  hideTimeLabels: 'Hide time labels',
  showTimeLabels: 'Show time labels',
  hideSpeedLabels: 'Hide speed labels',
  showSpeedLabels: 'Show speed labels',
  gpxParsingError: 'GPX parsing error',
  hideSpeedTrack: 'Hide speed',
  showSpeedTrack: 'Show speed',
  fullRes: 'Full resolution',
  plannedTracks: 'Plans',
  newPlannedTrack: 'New',
  offlineMaps: 'Offline maps',
  zoomFrom: 'Zoom from',
  zoomTo: 'to',
  mapNotOffline: 'Map is not offline layer',
  removeAllTitles: 'Remove all {0} titles?',
  saveAllTitles: 'Save {0} titles?\nZooms: {1}\nUrl template: {2}\nUse cache tiles: {3}',
  exportOffline: 'Export all',
  importOffline: 'Import maps',
  downloadOffline: 'Download',
  deleteOffline: 'Delete',
  noSleepActive: 'Screen lock activated',
  noSleepInactive: 'Screen lock deactivated',
  showLocation: 'Show position',
  hideLocation: 'Hide position',
  bitmapInDatabase: 'Bitmaps in batabase: {0}',
  allBitmapsRemoved: 'All bitmaps removed',
  starting: 'Staring...',
  countOffline: 'Count',
  importProgressLine: 'Readed: {0}MB; Bitmaps loaded: {1}',
  noBitmapsToExport: 'No bitmaps to export',
  importToDBError: 'Import to DB error',
  bitmapDownloadErrors: 'errors',
  threads: 'Threads',
  buildDate: 'Build date',
  notLoggedToAddPlace: 'You must be logged to add places',
  isApproved: 'Approved',
  fromContextMenuPosition: 'From click position',
  placeApproved: 'Approved',
  placeNotApproved: 'Unapproved',
  showApproved: 'Approved',
  showNotApproved: 'Unapproved',
  useCache: 'Use cache',
  showOffline: 'Show offline covarage',
  hideOffline: 'Hide offline coverage',
  showZoom: 'Zoom',
  areasDownloaded: '{0} areas downloaded',
  areasError: 'Error during areas download',
  saveArea: 'Save area',
  pleaseAreaName: 'Enter name: ',
  areaSaved: 'Area saved',
  areaSavedError: 'Error during area saving',
  areas: 'Areas',
  newArea: 'New',
  selectArea: 'Area',
  clearOffline: 'Clear DBs',
  countGlobalOffline: 'Count everything',
  removeTiles: 'Remove {0} tiles?',
  bitmapsRemoved: 'Bitmaps removed',
  showAllTracks: 'Show all',
  hideAllTracks: 'Hide all',
  expandAllGroups: 'Exapnd all',
  hideAllGroups: 'Hide all',
  someTilesMissing: '{0} bitmaps missing. Add anyway?',
  addToExport: 'Add area to export',
  sum: 'Sum',
  areasToExport: 'Areas to export',
  exportOfflineSelection: 'Export',
  clearSelection: 'Clear',
  activateAreas: 'Activate areas',
  setAsPrivate: 'Set as private',
  editPlace: 'Edit place',
  corsWarning: 'CORS! Close all Chrome instances, and run with --disable-web-security flag',
  day0: 'sunday',
  day1: 'monday',
  day2: 'tuesday',
  day3: 'wednesday',
  day4: 'thursday',
  day5: 'friday',
  day6: 'saturday',
  month0: 'january',
  month1: 'february',
  month2: 'match',
  month3: 'april',
  month4: 'may',
  month5: 'june',
  month6: 'july',
  month7: 'august',
  month8: 'september',
  month9: 'october',
  month10: 'november',
  month11: 'december',
  calendar: 'Calendar',
  search: 'Search...',
  openGallery: 'Open gallery',
  closeGallery: 'Close gallery',
  removeTrack: 'Remove track',
  openRuler: 'Start measure',
  closeRuler: 'Finish measure',
  layersDownloaded: '{0} layers downloaded',
  layersLoaded: '{0} layers loaded',
  layersError: 'Error during layers download',
  videos: 'Videos',
  trackVideos: 'Track videos',
  photosAndMovies: 'Photos and videos',
  myDone: 'Moja trasa',
  myPlanned: 'Mój plan',
  otherPeople: 'Cudza trasa',
  trial: 'Szlak',
  event: 'Wydarzenie',
  border: 'Obszar',
  tmpPlannedTracks: 'Nowe plany',
  eventTracks: 'Wydarzenia',
  otherPeopleTracks: 'Cudze trasy',
  borderTracks: 'Obszary',
  trailTracks: 'Szlaki',
  points: 'Punkty',
  stopDownloadOffline: 'Zatrzymaj',
  hideFollow: 'Zatrzymaj śledzenie',
  showFollow: 'Rozpocznij śledzenie',
  mushroom: 'Grzyby',
  mushrooms: 'Grzyby',
  roads: 'Drogi',
  lockPortrait: 'Blokuj orientację pionową w czasie nawigacji',
  lockCreated: 'Orinetacja pionowa zablokowana',
  lockError: 'Błąd blokowania orientacji pionowej',
  speedScale: 'Skale prędkości',
  countPhotoCache: 'Policz cache miniatur',
  useHTML5location: 'Use HTML5 location service',
  largeButtonsDuringLocation: 'Large buttons during location',
  showAllButtonsDuringLocation: 'Show all buttons during location',
  galleries: 'Galleries',
  add: 'Add',
  downloadExternalData: 'Download external data',
  toursDownloaded: '{0} tours downloaded',
  toursLoaded: '{0} tours loaded',
  dataRevisionError: 'Data revision error',
  gridDebug: 'Grid debug',
  state: 'State',
  style: 'Style',
  placesError: 'Places error',
  analyzeTrack: 'Analyze track',
  tmpPoints: 'Temporary points',
  center: 'Center',
  centerMap: 'Center map',
  cacheThumbs: 'Cache thumbs',
  debug: 'Debug',
  copyCoordinates: 'Copy coordinates',
  copied: 'Copied {0}',
  copyError: 'Copy error',
  palette: 'Palette',
  uniformTrackColor: 'Uniform track color',
  apply: 'Apply',
  restore: 'Restore',
  measureHeight: 'Measure height',
  measureHeightError: 'Measure error',
  startOffline: 'Start Offline',
  visitedTilesLoaded: 'Visited tiles loaded',
  visitedTilesDownloaded: 'Visited tiles downloaded',
  visitedTilesError: 'Visited tiles error',
  showOnlySelectedTracks: 'Show only selected tracks',
  addTrailPhotos: 'Add trail photos',
  clearTrailPhotos: 'Clear photos',
  saveTrailPhotos: 'Save photos',
  trailPhotos_processed_success: '{0} photos processed, {1} markers created',
  trailPhotos_no_exif: '{0} without EXIF',
  trailPhotos_read_errors: '{0} read errors',
  trailPhotos_markers_created: '{0} markers created',
  trailPhotos_cleared: '{0} trail photo markers cleared',
},
pl: {
  tracksDownloaded: '{0} trasy ściągnięte',
  tracksLoaded: '{0} trasy wczytane',
  placesDownloaded: '{0} miejsca ściągnięte',
  placesLoaded: '{0} miejsca wczytane',
  placeTypesDownloaded: '{0} typy miejsc ściągnięte',
  placeTypesLoaded: '{0} typy miejsc wczytane',
  tracksError: 'Błąd podczas ściągania tras',
  trackError: 'Błąd podczas ściągania trasy',
  mainMenu: 'Menu główne',
  tracks: 'Trasy',
  settings: 'Ustawienia',
  language: 'Język',
  tracksSelectedDistance: 'Dystans wybranych tras',
  tracksSelectedDistanceWalk: 'piesze',
  tracksSelectedDistanceBicycle: 'rowerowe',
  tracksSelectedDistanceMushroom: 'grzybobrania',
  tracksSelected: 'Wybrano {0} z {1} tras',
  colorSaved: 'Kolor zapisany',
  colorError: 'Błąd zapisywania koloru',
  color: 'Kolor',
  name: 'Nazwa',
  distance: 'Dystans',
  type: 'Rodzaj',
  startTime: 'Czas startu',
  endTime: 'Czas zakończenia',
  status: 'Status',
  id: 'ID',
  openMenu: 'Otwórz menu',
  closeMenu: 'Zamknij menu',
  showMyLocation: 'Pokaż moją lokalizację',
  enterFullscreen: 'Otwórz tryb pełnoekranowy',
  exitFullscreen: 'Zamknij tryb pełnoekranowy',
  zoomIn: 'Przybliż',
  zoomOut: 'Oddal',
  changeColor: 'Zmień kolor',
  saveTrack: 'Zapisz trasę',
  doneTrack: 'Trasa zakończona',
  plannedTrack: 'Trasa zaplanowana',
  walkTrack: 'Trasa piesza',
  bicycleTrack: 'Trasa rowerowa',
  mushroomTrack: 'Grzybobranie',
  centerTrack: 'Wyśrodkuj trasę',
  downloadGPX: 'Ściągnij plik GPX',
  groupBy: 'Grupuj według',
  unassigned: 'Nieprzypisane',
  walkTracks: 'Trasy piesze',
  bicycleTracks: 'Trasy rowerowe',
  mushroomTracks: 'Grzybobrania',
  year: 'Rok',
  region: 'Region',
  playTrack: 'Odtwarzaj trasę',
  stopTrack: 'Zatrzymaj odtwarzanie',
  playingSpeed: 'Prędkość odtwarzania',
  imports: 'Importy',
  importGpxFile: 'Importuj pliki GPX',
  importError: 'Błąd podczas importu pliku GPX',
  importNoTracks: 'Brak tras w pliku GPX',
  importSuccess: 'Plik GPX zaimportowany poprawnie',
  importNoFiles: 'Nie wybrano plików',
  regionsDownloaded: '{0} regiony sciągnięte',
  regionsLoaded: '{0} regiony wczytane',
  oneTrackError: 'Trasa zawiera błędy',
  regionsError: 'Błąd podczas ściągania regionów',
  trackSaveTitle: 'Zapisywanie trasy',
  uploadTrack: 'Zapisz trasę',
  trackSaved: 'Trasa zapisana',
  trackSavedError: 'Błąd podczas zapisywania trasy',
  description: 'Opis',
  loginForm: 'Logowanie',
  welcome: 'Witaj',
  logOut: 'Wyloguj',
  logIn: 'Zaloguj',
  login: 'Login',
  password: 'Hasło',
  logInError: 'Błędny login lub hasło',
  logInSuccess: 'Zalogowano poprawnie',
  logInSessionExpired: 'Sesja wygasła, zaloguj się ponownie',
  logOutSuccess: 'Wylogowano poprawnie',
  close: 'Zamknij',
  save: 'Zapisz',
  maximizeTrack: 'Pokaż szczegóły',
  gpxFile: 'Plik GPX',
  jsonFile: 'Plik JSON',
  importPhotoFile: 'Importuj zdjęcie',
  thumbnail: 'Podgląd',
  photoSaveTitle: 'Dodaj zdjęcie',
  coordinates: 'Współrzędne',
  addPhotoToMap: 'Dodaj zdjęcie',
  addPlaceToMap: 'Dodaj obiekt',
  photoAdded: 'Zdjęcie dodane',
  objects: 'Obiekty',
  places: 'Miejsca',
  addPlace: 'Dodaj miejsce',
  newPlace: 'Nowe miejsce',
  fromFirstPhoto: 'Z pierwszego zdjęcia',
  fromMapCenter: 'Z centrum mapy',
  manually: 'Ręcznie',
  photos: 'Zdjęcia',
  coordsError: 'Błędna lokalizacja GPS',
  placeSaved: 'Miejsce zapisane',
  placeSavedError: 'Błąd podczas zapisywania miejsca',
  photoSavedError: 'Błąd podczas zapisywania zdjęć',
  placeRefreshError: 'Błąd podczas ściągania miejsca',
  trackRefreshError: 'Błąd podczas ściągania trasy',
  placeCoordsSave: 'Współrzędne zapisane',
  placeCoordsSaveError: 'Błąd zapisu współrzędnych',
  hideTimeLabels: 'Ukryj et. czasu',
  showTimeLabels: 'Pokaż et. czasu',
  hideSpeedLabels: 'Ukryj et. prędkości',
  showSpeedLabels: 'Pokaż et. prędkości',
  gpxParsingError: 'Błąd parsowania GPX',
  hideSpeedTrack: 'Ukryj prędkość',
  showSpeedTrack: 'Pokaż prędkość',
  fullRes: 'Pełna rozdzielczość',
  plannedTracks: 'Plany',
  newPlannedTrack: 'Nowy',
  offlineMaps: 'Mapy offline',
  zoomFrom: 'Zoom od',
  zoomTo: 'do',
  mapNotOffline: 'Mapa nie jest warstwą offline',
  removeAllTitles: 'Usunąć wszystkie {0} bitmapy?',
  saveAllTitles: 'Zapisać {0} bitmapy?\nZoomy: {1}\nSzablon url: {2}\nWczytaj z cache: {3}',
  exportOffline: 'Exportuj wszystko',
  importOffline: 'Importuj mapy',
  downloadOffline: 'Ściągnij',
  deleteOffline: 'Usuń',
  noSleepActive: 'Blokada wygaszania ekranu jest aktywna',
  noSleepInactive: 'Blokada wygaszania ekranu nie jest aktywna',
  showLocation: 'Pokaż pozycję',
  hideLocation: 'Ukryj pozycję',
  bitmapInDatabase: 'Bitmap w bazie: {0}',
  allBitmapsRemoved: 'Wszystkie bitmapy usunięte',
  starting: 'Rozpoczynam',
  countOffline: 'Policz',
  importProgressLine: 'Przeczytano: {0}MB; Załadowano bitmap: {1}',
  noBitmapsToExport: 'Brak bitmap do exportu',
  importToDBError: 'Błąd importu',
  bitmapDownloadErrors: 'błędy',
  threads: 'Wątki',
  buildDate: 'Data buildu',
  notLoggedToAddPlace: 'Musisz być zalogowany by dodawać miejsca',
  isApproved: 'Potwierdzone',
  fromContextMenuPosition: 'Z punktu kliknięcia',
  placeApproved: 'Potwierdzone',
  placeNotApproved: 'Niepotwierdzone',
  showApproved: 'Potwierdzone',
  showNotApproved: 'Niepotwierdzone',
  useCache: 'Użyj cache',
  showOffline: 'Pokaż pokrycie',
  hideOffline: 'Ukryj pokrycie',
  showZoom: 'Zoom',
  areasDownloaded: '{0} obszary ściągnięte',
  areasError: 'Błąd podczas ściągania obszarów',
  saveArea: 'Zapisz obszar',
  pleaseAreaName: 'Podaj nazwę: ',
  areaSaved: 'Obszar zapisany',
  areaSavedError: 'Błąd zapisu obszaru',
  areas: 'Obszary',
  newArea: 'Nowy',
  selectArea: 'Obszar',
  clearOffline: 'Wyczyść bazy',
  countGlobalOffline: 'Policz wszystko',
  removeTiles: 'Usunąć {0} bitmapy?',
  bitmapsRemoved: 'Bitmapy usunięte',
  showAllTracks: 'Pokaż trasy',
  hideAllTracks: 'Ukryj trasy',
  expandAllGroups: 'Rozwiń grupy',
  hideAllGroups: 'Zwiń grupy',
  someTilesMissing: 'Brakuje {0} bitmap. Dodać mimo to?',
  addToExport: 'Dodaj do exportu',
  sum: 'Suma',
  areasToExport: 'Obszary do exportu',
  exportOfflineSelection: 'Exportuj',
  clearSelection: 'Resetuj',
  activateAreas: 'Aktywuj obszary',
  setAsPrivate: 'Ustaw jako prywatne',
  editPlace: 'Edytuj miejsce',
  corsWarning: 'CORS! Zamknij wszystkie okna Chrome i uruchom z flagą --disable-web-security.',
  day0: 'niedziela',
  day1: 'poniedziałek',
  day2: 'wtorek',
  day3: 'sroda',
  day4: 'czwartek',
  day5: 'piątek',
  day6: 'sobota',
  month0: 'styczeń',
  month1: 'luty',
  month2: 'marzec',
  month3: 'kwiecień',
  month4: 'maj',
  month5: 'czerwiec',
  month6: 'lipiec',
  month7: 'sierpień',
  month8: 'wrzesień',
  month9: 'październik',
  month10: 'listopad',
  month11: 'grudzień',
  calendar: 'Kalendarz',
  search: 'Szukaj...',
  openGallery: 'Otwórz galerię',
  closeGallery: 'Zamknij galerię',
  removeTrack: 'Usuń trasę',
  openRuler: 'Rozpocznij pomiar',
  closeRuler: 'Zakończ pomiar',
  layersDownloaded: '{0} map ściągniętych',
  layersLoaded: '{0} map wczytanych',
  layersError: 'Błąd podczas ściągania map',
  videos: 'Filmy',
  trackVideos: 'Filmy z trasy',
  photosAndMovies: 'Filmy i zdjęcia',
  useHTML5location: 'Używaj lokalizacji HTML5',
  largeButtonsDuringLocation: 'Większe przyciski podczas nawigacji',
  showAllButtonsDuringLocation: 'Pokaż wszystkie przyciski podczas nawigacji',
  myDone: 'Moja trasa',
  myPlanned: 'Mój plan',
  otherPeople: 'Cudza trasa',
  trial: 'Szlak',
  event: 'Wydarzenie',
  border: 'Obszar',
  tmpPlannedTracks: 'Nowe plany',
  eventTracks: 'Wydarzenia',
  otherPeopleTracks: 'Cudze trasy',
  borderTracks: 'Obszary',
  trailTracks: 'Szlaki',
  points: 'Punkty',
  stopDownloadOffline: 'Zatrzymaj',
  hideFollow: 'Zatrzymaj śledzenie',
  showFollow: 'Rozpocznij śledzenie',
  mushroom: 'Grzyby',
  mushrooms: 'Grzyby',
  roads: 'Drogi',
  lockPortrait: 'Blokuj orientację pionową w czasie nawigacji',
  lockCreated: 'Orinetacja pionowa zablokowana',
  lockError: 'Błąd blokowania orientacji pionowej',
  speedScale: 'Skale prędkości',
  countPhotoCache: 'Policz cache miniatur',
  galleries: 'Galerie',
  add: 'Dodaj',
  downloadExternalData: 'Pobierz zewnętrzne dane',
  toursDownloaded: '{0} trasy ściągnięte',
  toursLoaded: '{0} trasy wczytane',
  dataRevisionError: 'Błąd rewizji danych',
  gridDebug: 'Debug siatki',
  state: 'Stan',
  style: 'Styl',
  placesError: 'Błąd miejsc',
  analyzeTrack: 'Analizuj trasę',
  tmpPoints: 'Punkty tymczasowe',
  center: 'Centruj',
  centerMap: 'Centruj mapę',
  cacheThumbs: 'Cachuj miniatury',
  debug: 'Debug',
  copyCoordinates: 'Kopiuj współrzędne',
  copied: 'Skopiowane: {0}',
  copyError: 'Błąd kopiowania',
  palette: 'Paleta',
  uniformTrackColor: 'Jednolity kolor tras',
  apply: 'Zastosuj',
  restore: 'Przywróć',
  measureHeight: 'Pomiar wysokości',
  measureHeightError: 'Błąd pomiaru',
  startOffline: 'Zacznij Offline',
  visitedTilesLoaded: 'Odwiedzone kafelki wczytane',
  visitedTilesDownloaded: 'Odwiedzone kafelki ściągnięte',
  visitedTilesError: 'Błąd odwiedzonych kafelków',
  showOnlySelectedTracks: 'Pokaż tylko zaznaczone trasy',
  showGPX: 'Pokaż GPX',
  hideGPX: 'Ukryj GPX',
  showJSON: 'Pokaż JSON',
  hideJSON: 'Ukryj JSON',
  showPush: 'Pokaż pchanie',
  hidePush: 'Ukryj pchanie',
  showMarkers: 'Pokaż markery',
  addTrailPhotos: 'Dodaj zdjęcia szlaku',
  clearTrailPhotos: 'Wyczyść zdjęcia',
  saveTrailPhotos: 'Zapisz zdjęcia',
  trailPhotos_processed_success: '{0} zdjęć wczytanych, {1} markerów utworzonych',
  trailPhotos_no_exif: '{0} bez EXIF',
  trailPhotos_read_errors: '{0} błędów odczytu',
  trailPhotos_markers_created: '{0} markerów utworzonych',
  trailPhotos_cleared: '{0} markerów zdjęć szlaku usuniętych',
}};

const i18n = createI18n({locale: 'en', fallbackLocale: 'en', messages});
export default i18n
